import { render } from "./EduRegisterConfirmView.vue?vue&type=template&id=0870eb34"
import script from "./EduRegisterConfirmView.vue?vue&type=script&lang=js"
export * from "./EduRegisterConfirmView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__